import type { IconData } from '@stacksjs/iconify-core'

export const contentWrite: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 9v7h7l9-9l-7-7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentWrite
